// src/pages/subscription/PlanEditPage.tsx
// Legacy route kept resolvable for old links/bookmarks. Plans are edited
// inline on PlanDetailPage now (PlanFormDialog reused for edit) — there is
// no edit route/mode, per docs/ux/14-forms.md. This route just sends people
// to the detail page.

import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const PlanEditPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    navigate(id ? `/subscriptions/plans/${id}` : '/subscriptions/plans', { replace: true });
  }, [navigate, id]);
  return null;
};

export default PlanEditPage;
